import { useSyncExternalStore } from 'react';

// Токен админа живёт в localStorage этого origin'а (newadmin.fastfresh.ru) — со старой
// админкой он не общий, логиниться нужно отдельно. Cookie ff_token на .fastfresh.ru нужна
// nginx'у для auth_request к Redash (как в старой админке).
const TOKEN_KEY = 'ff_admin_token';
const COOKIE_MAX_AGE = 7 * 24 * 3600; // JWT живёт 7 дней

// Вход — через Telegram OIDC на app.fastfresh.ru: именно его redirect_uri зарегистрирован
// в консоли Telegram. Бэк вернёт на return_to с ?token=.
const LOGIN_URL = 'https://app.fastfresh.ru/auth/admin-login';

type Listener = () => void;
const listeners = new Set<Listener>();

function readToken(): string | null {
    try {
        return localStorage.getItem(TOKEN_KEY);
    } catch {
        return null;
    }
}

let token = readToken();

function emit() {
    listeners.forEach((l) => l());
}

function cookieDomain(): string | null {
    const host = window.location.hostname;
    return host.endsWith('fastfresh.ru') ? '.fastfresh.ru' : null;
}

export function getToken() {
    return token;
}

export function setToken(value: string) {
    token = value;
    try {
        localStorage.setItem(TOKEN_KEY, value);
    } catch {
        /* приватный режим — живём без сохранения */
    }
    const domain = cookieDomain();
    if (domain) {
        document.cookie = `ff_token=${value}; Path=/; Domain=${domain}; Max-Age=${COOKIE_MAX_AGE}; SameSite=Lax; Secure`;
    }
    emit();
}

export function clearToken() {
    token = null;
    try {
        localStorage.removeItem(TOKEN_KEY);
    } catch {
        /* noop */
    }
    const domain = cookieDomain();
    if (domain) {
        document.cookie = `ff_token=; Path=/; Domain=${domain}; Max-Age=0; SameSite=Lax; Secure`;
    }
    emit();
}

/** Забирает ?token= после OIDC-редиректа и вычищает его из адресной строки. */
export function consumeTokenFromUrl() {
    const url = new URL(window.location.href);
    const fromUrl = url.searchParams.get('token');
    if (!fromUrl) return;
    url.searchParams.delete('token');
    window.history.replaceState(null, '', url.pathname + url.search + url.hash);
    setToken(fromUrl);
}

export function loginUrl() {
    const returnTo = `${window.location.origin}/`;
    return `${LOGIN_URL}?return_to=${encodeURIComponent(returnTo)}`;
}

export function useToken() {
    return useSyncExternalStore(
        (cb) => {
            listeners.add(cb);
            return () => listeners.delete(cb);
        },
        () => token
    );
}
